/*=========================================================================================
  File Name: moduleCompanyGetters.js
  Description: Company Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	//getItem: state => (companyId) => state.companies.find((company) => company.id == companyId),
	getAllSessions: (state) => () => state.sessions,
};
